import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
// import { ToastrService } from 'ngx-toastr'
// import { Store } from '@ngrx/store'
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import {
  createAssignedPermissionSets,
  createAssignedPermissionSetsSuccess,
  loadAssignedPermissionSets,
  loadAssignedPermissionSetsFailure,
  loadAssignedPermissionSetsSuccess,
  updateAssignedPermissionSets,
  updateAssignedPermissionSetsFailure,
  updateAssignedPermissionSetsSuccess
} from './assigned-permissionsets.actions'
import { AssignedPermissionSetsService } from '../../services/assigned-permissionsets.service'
import { ToastrService } from 'ngx-toastr'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { createRoleFailure } from '../role-permission/role-permission.actions'
import { Store } from '@ngrx/store'

export const loadAssignedPermissionSets$ = createEffect(
  (
    actions$ = inject(Actions),
    assignedPermissionSetservice = inject(AssignedPermissionSetsService)
  ) =>
    actions$.pipe(
      ofType(loadAssignedPermissionSets),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          assignedPermissionSetservice
            .getAssignedPermissionSets(action.id, action.params, action.page, action.limit)
            .pipe(
              map(res =>
                loadAssignedPermissionSetsSuccess({
                  totalCount: res.totalCount,
                  assignedPermissionSets: res.permissionSets
                })
              ),
              catchError(error => of(loadAssignedPermissionSetsFailure({ error: error.message })))
            )
      )
    ),
  { functional: true }
)

export const createAssignedPermissionSets$ = createEffect(
  (
    actions$ = inject(Actions),
    assignedPermissionSetservice = inject(AssignedPermissionSetsService),
    toastr = inject(ToastrService),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(createAssignedPermissionSets),
      switchMap(({ validUpto, permissionSetIds, userId }) =>
        assignedPermissionSetservice
          .createAssignedPermissionSets({
            validUpto,
            permissionSetIds,
            userId
          })
          .pipe(
            map(created => {
              toastr.success('Permission sets assigned successfully!', 'Success')
              //store.dispatch(loadAssignedPermissionSets({ params: null, page: 1, limit: 10 }))
              modalService.dismissAll()
              return createAssignedPermissionSetsSuccess({
                assignedPermissionSets: created
              })
            }),
            catchError(error => {
              // Optionally, show an error message
              toastr.error('There was an error creating the record.', 'Error')
              return of(createRoleFailure({ error }))
            })
          )
      )
    ),
  { functional: true, dispatch: true }
)

export const updateAssignedPermissionSets$ = createEffect(
  (
    actions$ = inject(Actions),
    assignedPermissionSetservice = inject(AssignedPermissionSetsService),
    toastr = inject(ToastrService),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(updateAssignedPermissionSets),
      switchMap(({ id, validUpto, userRoleId, userId }) =>
        assignedPermissionSetservice
          .updateAssignedPermissionSets({
            id,
            validUpto,
            userRoleId,
            userId
          })
          .pipe(
            map(updatedRole => {
              toastr.success('Role updated successfully!', 'Success')

              // Dispatch loadBusinessById after the update is successful
              //store.dispatch(loadAssignedPermissionSets({ params: null }))
              modalService.dismissAll()
              // Dispatch success action to update the store
              return updateAssignedPermissionSetsSuccess({ assignedPermissionSet: updatedRole })
            }),
            catchError(error => {
              toastr.error('Failed to update Role', 'Error') // Show error message
              return of(updateAssignedPermissionSetsFailure({ error }))
            })
          )
      )
    ),
  { functional: true }
)

export const assignedPermissionSetsEffects = {
  loadAssignedPermissionSets$,
  createAssignedPermissionSets$,
  updateAssignedPermissionSets$
}
